/**
 * Created by Thomas Mark
 * Date: 2019-10-29
 * Description:
 *
 */

import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as utils from "../../basics/utils"
import * as appActions from "../../store/actions/appActions";
import { Icon } from "./Icons";


class BreadCrumpShort extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false;
    }

    render() {
        const { headerHeight, path } = this.props.app
        const dialog = utils.getDialogByPath(path);

        const style = { color: 'rgb(107,107,107)', backgroundColor: 'rgba(255,255,255,.5)', ...utils.getStyleHeight(headerHeight, 1.0, 1.0, .3) };

        let backPath = (dialog.dialogType === 'groups') ? '' : dialog.portfolio;
        let backTitle = (dialog.dialogType === 'groups') ? 'Portfolio' : dialog.portfolio;

        return (
            <div className="absolute top-0 w-full" style={style} >
                <ul className="flex flex-row items-center" onClick={() => this.props.setPath(backPath)}>
                    <li><Icon type='left' color='rgb(107,107,107)' width={headerHeight * .5} height={headerHeight * .5} /></li>
                    <li><div>{backTitle}</div></li>
                </ul>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(BreadCrumpShort);
